import { render, staticRenderFns } from "./PictureSVG.vue?vue&type=template&id=67167552&"
import script from "./PictureSVG.vue?vue&type=script&lang=js&"
export * from "./PictureSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports